export declare type IconName =
  | 'talend-activemq'
  | 'talend-amazon-aurora'
  | 'talend-amazon-redshift'
  | 'talend-apache-derby'
  | 'talend-apache-kudu'
  | 'talend-apache'
  | 'talend-aws-kinesis'
  | 'talend-azure-cosmosDB'
  | 'talend-azure-dynamics'
  | 'talend-azure-synapse'
  | 'talend-azure'
  | 'talend-beam'
  | 'talend-box'
  | 'talend-cassandra'
  | 'talend-cloudstorage'
  | 'talend-couchbase'
  | 'talend-delta-lake'
  | 'talend-dynamodb'
  | 'talend-elastic'
  | 'talend-flink-o'
  | 'talend-flink'
  | 'talend-google-analytics'
  | 'talend-google-bigtable'
  | 'talend-google-dataflow'
  | 'talend-hadoop'
  | 'talend-jms'
  | 'talend-kafka'
  | 'talend-mariadb'
  | 'talend-marketo'
  | 'talend-microsoft-sql-server'
  | 'talend-mongodb'
  | 'talend-mysql'
  | 'talend-neo4j'
  | 'talend-netsuite'
  | 'talend-oracle'
  | 'talend-postgresql'
  | 'talend-pubsub'
  | 'talend-pulsar'
  | 'talend-python'
  | 'talend-rabbitmq'
  | 'talend-singlestore'
  | 'talend-snowflake'
  | 'talend-spark'
  | 'talend-tableau'
  | 'talend-thoughtspot'
  | 'talend-workday'
  | 'talend-calendar-move'
  | 'talend-column-chooser'
  | 'talend-datagrid'
  | 'talend-drag-and-drop'
  | 'talend-drag'
  | 'talend-empty-calendar'
  | 'talend-empty-cell'
  | 'talend-empty-char'
  | 'talend-empty-space'
  | 'talend-raw-data'
  | 'talend-rest'
  | 'talend-abc'
  | 'talend-activity'
  | 'talend-api'
  | 'talend-applications'
  | 'talend-arrow-left'
  | 'talend-arrow-right'
  | 'talend-badge-outline'
  | 'talend-badge'
  | 'talend-bell-notification'
  | 'talend-bell'
  | 'talend-block'
  | 'talend-board'
  | 'talend-boolean'
  | 'talend-broom'
  | 'talend-bubbles'
  | 'talend-burger'
  | 'talend-campaigns'
  | 'talend-caret-down'
  | 'talend-carriage-return'
  | 'talend-chain'
  | 'talend-character'
  | 'talend-charts'
  | 'talend-check-circle'
  | 'talend-check-plus'
  | 'talend-check'
  | 'talend-chevron-end'
  | 'talend-chevron-left'
  | 'talend-classify'
  | 'talend-clock'
  | 'talend-cloud-engine'
  | 'talend-cloud-upgrade'
  | 'talend-cluster'
  | 'talend-cog'
  | 'talend-collapse'
  | 'talend-comment'
  | 'talend-component-negative'
  | 'talend-component-positive'
  | 'talend-connections'
  | 'talend-conversion'
  | 'talend-credits-engine'
  | 'talend-cross-circle'
  | 'talend-cross'
  | 'talend-crosshairs'
  | 'talend-cut'
  | 'talend-data-models'
  | 'talend-data-services'
  | 'talend-datasets'
  | 'talend-datastore'
  | 'talend-download'
  | 'talend-dropper'
  | 'talend-ellipsis'
  | 'talend-environment'
  | 'talend-error'
  | 'talend-expanded'
  | 'talend-export-history'
  | 'talend-export'
  | 'talend-eye-slash'
  | 'talend-eye'
  | 'talend-fieldglass'
  | 'talend-filter'
  | 'talend-flag'
  | 'talend-flash'
  | 'talend-folder-closed'
  | 'talend-folder-shared-owner'
  | 'talend-folder-shared-user'
  | 'talend-folder-shared'
  | 'talend-folder'
  | 'talend-format'
  | 'talend-fullscreen'
  | 'talend-group-circle'
  | 'talend-group'
  | 'talend-grouping'
  | 'talend-hand-pointer'
  | 'talend-hierarchical-view'
  | 'talend-history'
  | 'talend-home'
  | 'talend-import'
  | 'talend-info-circle'
  | 'talend-launch'
  | 'talend-launcher'
  | 'talend-license'
  | 'talend-line-charts'
  | 'talend-link'
  | 'talend-list'
  | 'talend-local-storage'
  | 'talend-lock'
  | 'talend-locked'
  | 'talend-mask'
  | 'talend-maths'
  | 'talend-merge'
  | 'talend-minus-circle'
  | 'talend-most-trusted'
  | 'talend-network'
  | 'talend-note'
  | 'talend-numbers'
  | 'talend-open-window'
  | 'talend-opener'
  | 'talend-overview'
  | 'talend-panel-opener-bottom'
  | 'talend-panel-opener-right'
  | 'talend-pause'
  | 'talend-pencil'
  | 'talend-phone'
  | 'talend-pie-charts'
  | 'talend-pin'
  | 'talend-placeholder'
  | 'talend-play'
  | 'talend-plus-circle'
  | 'talend-plus'
  | 'talend-power-off'
  | 'talend-projects'
  | 'talend-promotion-pipelines'
  | 'talend-question-circle'
  | 'talend-quotes'
  | 'talend-re-cluster'
  | 'talend-redo'
  | 'talend-refresh'
  | 'talend-remote-engine'
  | 'talend-replicate'
  | 'talend-restart'
  | 'talend-roles'
  | 'talend-routes'
  | 'talend-rules'
  | 'talend-sample'
  | 'talend-scheduler'
  | 'talend-search'
  | 'talend-semantic'
  | 'talend-send'
  | 'talend-share-alt'
  | 'talend-sharing-default'
  | 'talend-sharing-owner'
  | 'talend-sharing-user'
  | 'talend-shield-full-check'
  | 'talend-shield-full'
  | 'talend-shield'
  | 'talend-show_unassigned_tasks'
  | 'talend-sliders'
  | 'talend-smiley-angry'
  | 'talend-smiley-enthusiast'
  | 'talend-smiley-neutral'
  | 'talend-smiley-satisfied'
  | 'talend-smiley-sleep'
  | 'talend-smiley-unhappy'
  | 'talend-sort-19'
  | 'talend-sort-91'
  | 'talend-sort-asc'
  | 'talend-sort-az'
  | 'talend-sort-desc'
  | 'talend-sort-za'
  | 'talend-sort'
  | 'talend-star'
  | 'talend-stop'
  | 'talend-streams'
  | 'talend-table'
  | 'talend-tags'
  | 'talend-tasks'
  | 'talend-text'
  | 'talend-tiles'
  | 'talend-trash'
  | 'talend-undo'
  | 'talend-ungroup'
  | 'talend-union'
  | 'talend-unlocked'
  | 'talend-upload'
  | 'talend-user-circle'
  | 'talend-variable'
  | 'talend-versioning'
  | 'talend-warning'
  | 'talend-webhook'
  | 'talend-word'
  | 'talend-workspaces'
  | 'talend-world'
  | 'talend-wrench'
  | 'talend-zoomin'
  | 'talend-zoomout'
  | 'talend-file-cog'
  | 'talend-file-compressed'
  | 'talend-file-connect-o'
  | 'talend-file-csv-o'
  | 'talend-file-database-o'
  | 'talend-file-hdfs-o'
  | 'talend-file-job-o'
  | 'talend-file-json-o'
  | 'talend-file-move'
  | 'talend-file-o'
  | 'talend-file-s3-o'
  | 'talend-file-salesforce'
  | 'talend-file-txt-o'
  | 'talend-file-xls-o'
  | 'talend-file-xlsx-o'
  | 'talend-file-xml-o'
  | 'talend-files-o'
  | 'talend-flow-o'
  | 'talend-flow-source-o'
  | 'talend-flow-source-target'
  | 'talend-flow-step-o'
  | 'talend-flow-target-o'
  | 'talend-flow-under-plan'
  | 'talend-flow-unfinished'
  | 'talend-flow'
  | 'talend-between'
  | 'talend-contains'
  | 'talend-ends-with'
  | 'talend-equal'
  | 'talend-greater-than-equal'
  | 'talend-greater-than'
  | 'talend-less-than-equal'
  | 'talend-less-than'
  | 'talend-not-contains'
  | 'talend-not-equal'
  | 'talend-regex'
  | 'talend-starts-with'
  | 'talend-aggregate'
  | 'talend-azure-blob'
  | 'talend-azure-datalake'
  | 'talend-azure-event-hubs'
  | 'talend-bigquery'
  | 'talend-concatenate'
  | 'talend-db-input'
  | 'talend-delete-field'
  | 'talend-field-remover'
  | 'talend-field-selector'
  | 'talend-filter-column'
  | 'talend-filter-row'
  | 'talend-ftp'
  | 'talend-generator'
  | 'talend-hash-knife'
  | 'talend-map'
  | 'talend-normalize'
  | 'talend-parser'
  | 'talend-semantic-filter'
  | 'talend-shape-tools'
  | 'talend-transformer-window'
  | 'talend-type-converter'
  | 'talend-window'
  | 'talend-api-designer-colored'
  | 'talend-api-designer-favicon'
  | 'talend-api-designer-negative'
  | 'talend-api-designer-positive'
  | 'talend-api-tester-colored'
  | 'talend-api-tester-favicon'
  | 'talend-api-tester-negative'
  | 'talend-api-tester-positive'
  | 'talend-component-kit-colored'
  | 'talend-component-kit-favicon'
  | 'talend-component-kit-negative'
  | 'talend-component-kit-positive'
  | 'talend-data-fabric-colored'
  | 'talend-data-fabric-favicon'
  | 'talend-data-fabric-negative'
  | 'talend-data-fabric-positive'
  | 'talend-datacatalog-colored'
  | 'talend-datacatalog-favicon'
  | 'talend-datacatalog-negative'
  | 'talend-datacatalog-positive'
  | 'talend-dataprep'
  | 'talend-datastreams-colored'
  | 'talend-datastreams-favicon'
  | 'talend-datastreams-negative'
  | 'talend-datastreams-positive'
  | 'talend-logo-colored'
  | 'talend-logo-square'
  | 'talend-logo'
  | 'talend-mdm-colored'
  | 'talend-mdm-favicon'
  | 'talend-mdm-negative'
  | 'talend-mdm-positive'
  | 'talend-qlik-colored'
  | 'talend-qlik-favicon'
  | 'talend-qlik-logo-colored'
  | 'talend-qlik-logo-white'
  | 'talend-qlik-negative'
  | 'talend-studio-colored'
  | 'talend-studio-favicon'
  | 'talend-studio-negative'
  | 'talend-studio-positive'
  | 'talend-tdc-colored'
  | 'talend-tdc-favicon'
  | 'talend-tdc-negative'
  | 'talend-tdc-positive'
  | 'talend-tdp-colored'
  | 'talend-tdp-favicon'
  | 'talend-tdp-negative'
  | 'talend-tdp-positive'
  | 'talend-tds-colored'
  | 'talend-tds-favicon'
  | 'talend-tds-negative'
  | 'talend-tds-positive'
  | 'talend-tic-colored'
  | 'talend-tic-favicon'
  | 'talend-tic-negative'
  | 'talend-tic-positive'
  | 'talend-tmc-colored'
  | 'talend-tmc-favicon'
  | 'talend-tmc-negative'
  | 'talend-tmc-positive'
  | string;

export declare type LegacyIcon = { name: IconName };

export const sizes = ['L', 'M', 'S', 'XS'] as const;

export const icons = {
  L: [
    'SQL-templates',
    'api',
    'application',
    'arrow-bottom',
    'arrow-left',
    'arrow-lines',
    'arrow-right',
    'arrow-top',
    'arrows-expand',
    'asterisk',
    'badge-outline',
    'badge-star',
    'badge',
    'bar-charts',
    'bell',
    'blackboard',
    'book-open',
    'book',
    'box',
    'broom',
    'bubbles',
    'calendar-arrow-right',
    'calendar',
    'chain',
    'chat',
    'check-filled',
    'check-plus',
    'check-stroke',
    'check',
    'checklist',
    'chevron-double-left-filled',
    'chevron-double-left-stroke',
    'chevron-double-left',
    'chevron-double-right-filled',
    'chevron-double-right-stroke',
    'chevron-double-right',
    'chevron-down-filled',
    'chevron-down-stroke',
    'chevron-down',
    'chevron-left-filled',
    'chevron-left-stroke',
    'chevron-left',
    'chevron-right-filled',
    'chevron-right-stroke',
    'chevron-right',
    'chevron-up-filled',
    'chevron-up-stroke',
    'chevron-up',
    'circle-slash',
    'clipperboard-chart',
    'clipperboard-checklist',
    'clipperboard-user',
    'clock-arrow-back',
    'clock',
    'cloud-arrow-right',
    'cloud-arrow-up',
    'cluster',
    'code',
    'collapse',
    'columns',
    'conversion',
    'copy',
    'cross-filled',
    'cross-stroke',
    'cross',
    'crosshairs',
    'curly-braces',
    'curve',
    'database-arrow-right',
    'database',
    'datagrid',
    'dataset',
    'detect-jobs',
    'diverge',
    'document',
    'dots-horizontal',
    'dots-vertical',
    'double-arrows',
    'download',
    'drag-and-drop',
    'dropper',
    'empty-cell',
    'empty-char',
    'empty-space',
    'erlenmeyer',
    'exclamation-stroke',
    'exclamation',
    'export',
    'external-link',
    'eye-slash',
    'eye',
    'field-glass',
    'file-code',
    'filter-column',
    'filter-row',
    'filter',
    'flag',
    'flash',
    'flow-filled',
    'flow-outline',
    'flow-source-filled',
    'flow-source-outline',
    'flow-source-target',
    'flow-step-filled',
    'flow-step-outline',
    'flow-target-filled',
    'flow-target-outline',
    'flow-unfinished',
    'folder-closed',
    'folder-opened',
    'folder-plus',
    'folder-shared',
    'generator',
    'group',
    'hand-pointer',
    'hierchical-bottom',
    'hierchical-right',
    'home',
    'import',
    'information-filled',
    'information-stroke',
    'job',
    'key',
    'law-hammer',
    'lightbulb',
    'line-chart',
    'locker-closed',
    'locker-opened',
    'magnifying-glass',
    'mapper',
    'megaphone',
    'merge',
    'micro-chip',
    'minus-filled',
    'minus-stroke',
    'minus',
    'network',
    'normalize',
    'note-pencil',
    'note',
    'operators',
    'overview',
    'panel-bottom',
    'panel-left',
    'panel-right',
    'pencil',
    'platform',
    'plus-filled',
    'plus-stroke',
    'plus',
    'power',
    'promote',
    'puzzle-filled',
    'puzzle-outline',
    'question-filled',
    'question-stroke',
    'redo',
    'refresh',
    'restart',
    'rows',
    'scissor',
    'share-filled',
    'share-left-filled',
    'share-outline',
    'share-right-filled',
    'shared-project',
    'shield-full-check',
    'shield-full',
    'shield-half',
    'shield',
    'six-dots',
    'slider-controls',
    'smiley-angry',
    'smiley-happy',
    'smiley-neutral',
    'smiley-sad',
    'smiley-satisfied',
    'smiley-sleepy',
    'sort-19',
    'sort-91',
    'sort-asc',
    'sort-az',
    'sort-desc',
    'sort-za',
    'square-a',
    'square-abc',
    'square-backspace',
    'square-circle',
    'square-cross',
    'square-curly-braces',
    'stack',
    'star',
    'support-agent',
    'switch',
    'table',
    'tag',
    'test-tube',
    'text',
    'thumbs-up',
    'tiles',
    'tokens',
    'trash',
    'triangle-circle',
    'triangle-restart',
    'two-vertical-lines-circle',
    'undo',
    'ungroup',
    'upload',
    'user-circle',
    'user-group',
    'user',
    'waves',
    'wheel',
    'window-arrow',
    'windows',
    'workspace',
    'world',
    'zoom-lines',
    'zoom-minus',
    'zoom-plus',
  ],
  M: [
    'SQL-templates',
    'api',
    'application',
    'arrow-bottom',
    'arrow-left',
    'arrow-lines',
    'arrow-right',
    'arrow-top',
    'arrows-expand',
    'asterisk',
    'badge-outline',
    'badge-star',
    'badge',
    'bar-charts',
    'bell',
    'between',
    'blackboard',
    'book-open',
    'book',
    'box',
    'broom',
    'bubbles',
    'calendar-arrow-right',
    'calendar',
    'chain',
    'chat',
    'check-filled',
    'check-plus',
    'check-stroke',
    'check',
    'checklist',
    'chevron-double-left-filled',
    'chevron-double-left-stroke',
    'chevron-double-left',
    'chevron-double-right-filled',
    'chevron-double-right-stroke',
    'chevron-double-right',
    'chevron-down-filled',
    'chevron-down-stroke',
    'chevron-down',
    'chevron-left-filled',
    'chevron-left-stroke',
    'chevron-left',
    'chevron-right-filled',
    'chevron-right-stroke',
    'chevron-right',
    'chevron-up-filled',
    'chevron-up-stroke',
    'chevron-up',
    'circle-slash',
    'clipperboard-chart',
    'clipperboard-checklist',
    'clipperboard-user',
    'clock-arrow-back',
    'clock',
    'cloud-arrow-right',
    'cloud-arrow-up',
    'cluster',
    'code',
    'collapse',
    'columns',
    'contains',
    'conversion',
    'copy',
    'cross-filled',
    'cross-stroke',
    'cross',
    'crosshairs',
    'curly-braces',
    'curve',
    'database-arrow-right',
    'database',
    'datagrid',
    'dataset',
    'detect-jobs',
    'diverge',
    'document',
    'does-not-contains',
    'dots-horizontal',
    'dots-vertical',
    'double-arrows',
    'download',
    'drag-and-drop',
    'drop-down',
    'drop-up',
    'dropper',
    'empty-cell',
    'empty-char',
    'empty-space',
    'ends-with',
    'equal',
    'erlenmeyer',
    'exclamation-stroke',
    'exclamation',
    'export',
    'external-link',
    'eye-slash',
    'eye',
    'field-glass',
    'file-code',
    'filter-column',
    'filter-row',
    'filter',
    'flag',
    'flash',
    'flow-filled',
    'flow-outline',
    'flow-source-filled',
    'flow-source-outline',
    'flow-source-target',
    'flow-step-filled',
    'flow-step-outline',
    'flow-target-filled',
    'flow-target-outline',
    'flow-unfinished',
    'folder-closed',
    'folder-opened',
    'folder-plus',
    'folder-shared',
    'generator',
    'greater-than',
    'group',
    'hand-pointer',
    'hierchical-bottom',
    'hierchical-right',
    'home',
    'import',
    'information-filled',
    'information-stroke',
    'job',
    'key',
    'law-hammer',
    'less-than',
    'lightbulb',
    'line-chart',
    'locker-closed',
    'locker-opened',
    'magnifying-glass',
    'mapper',
    'megaphone',
    'merge',
    'micro-chip',
    'minus-filled',
    'minus-stroke',
    'minus',
    'network',
    'normalize',
    'not-equal',
    'note-pencil',
    'note',
    'operators',
    'overview',
    'panel-bottom',
    'panel-left',
    'panel-right',
    'pencil',
    'platform',
    'plus-filled',
    'plus-stroke',
    'plus',
    'power',
    'promote',
    'puzzle-filled',
    'puzzle-outline',
    'question-filled',
    'question-stroke',
    'redo',
    'refresh',
    'regex',
    'restart',
    'rows',
    'scissor',
    'share-filled',
    'share-left-filled',
    'share-outline',
    'share-right-filled',
    'shared-project',
    'shield-full-check',
    'shield-full',
    'shield-half',
    'shield',
    'six-dots',
    'slider-controls',
    'smiley-angry',
    'smiley-happy',
    'smiley-neutral',
    'smiley-sad',
    'smiley-satisfied',
    'smiley-sleepy',
    'sort-19',
    'sort-91',
    'sort-asc',
    'sort-az',
    'sort-desc',
    'sort-za',
    'square-a',
    'square-abc',
    'square-backspace',
    'square-circle',
    'square-cross',
    'square-curly-braces',
    'stack',
    'star',
    'starts-with',
    'support-agent',
    'switch',
    'table',
    'tag',
    'test-tube',
    'text',
    'thumbs-up',
    'tiles',
    'tokens',
    'trash',
    'triangle-circle',
    'triangle-restart',
    'two-vertical-lines-circle',
    'undo',
    'ungroup',
    'upload',
    'user-circle',
    'user-group',
    'user',
    'waves',
    'wheel',
    'window-arrow',
    'windows',
    'workspace',
    'world',
    'zoom-lines',
    'zoom-minus',
    'zoom-plus',
  ],
  S: [
    'SQL-templates',
    'application',
    'arrow-bottom',
    'arrow-left',
    'arrow-right',
    'arrow-top',
    'arrows-expand',
    'asterisk',
    'bar-charts',
    'bell',
    'between',
    'blackboard',
    'book',
    'box',
    'calendar-arrow-right',
    'calendar',
    'chain',
    'chat',
    'check-filled',
    'check-plus',
    'check-stroke',
    'check',
    'checklist',
    'chevron-double-left',
    'chevron-double-right',
    'chevron-down-filled',
    'chevron-down-stroke',
    'chevron-down',
    'chevron-left-filled',
    'chevron-left-stroke',
    'chevron-left',
    'chevron-right-filled',
    'chevron-right-stroke',
    'chevron-right',
    'chevron-up-filled',
    'chevron-up-stroke',
    'chevron-up',
    'circle-slash',
    'clipperboard-chart',
    'clipperboard-checklist',
    'clipperboard-user',
    'clock',
    'cloud-arrow-up',
    'cluster',
    'code',
    'collapse',
    'columns',
    'contains',
    'copy',
    'cross-filled',
    'cross-stroke',
    'cross',
    'curly-braces',
    'curve',
    'database',
    'datagrid',
    'dataset',
    'diverge',
    'document',
    'does-not-contains',
    'dots-horizontal',
    'dots-vertical',
    'double-arrows',
    'download',
    'drag-and-drop',
    'drop-down',
    'drop-up',
    'empty-cell',
    'empty-char',
    'empty-space',
    'ends-with',
    'equal',
    'erlenmeyer',
    'exclamation-stroke',
    'exclamation',
    'export',
    'external-link',
    'eye-slash',
    'eye',
    'filter',
    'flag',
    'flash',
    'folder-closed',
    'folder-opened',
    'greater-than',
    'group',
    'hierchical-bottom',
    'hierchical-right',
    'home',
    'import',
    'information-filled',
    'information-stroke',
    'job',
    'key',
    'law-hammer',
    'less-than',
    'line-chart',
    'locker-closed',
    'locker-opened',
    'magnifying-glass',
    'merge',
    'micro-chip',
    'minus-filled',
    'minus-stroke',
    'minus',
    'not-equal',
    'note-pencil',
    'overview',
    'panel-bottom',
    'panel-left',
    'panel-right',
    'pencil',
    'plus-filled',
    'plus-stroke',
    'plus',
    'power',
    'question-filled',
    'redo',
    'refresh',
    'regex',
    'rows',
    'share-filled',
    'share-left-filled',
    'share-outline',
    'share-right-filled',
    'shield-full-check',
    'shield-full',
    'shield-half',
    'shield',
    'six-dots',
    'square-a',
    'square-backspace',
    'square-circle',
    'square-cross',
    'square-curly-braces',
    'stack',
    'star',
    'starts-with',
    'table',
    'tag',
    'test-tube',
    'tiles',
    'tokens',
    'trash',
    'triangle-circle',
    'undo',
    'ungroup',
    'upload',
    'user-circle',
    'user',
    'wheel',
    'window-arrow',
    'windows',
  ],
  XS: [
    'arrow-bottom',
    'arrow-left',
    'arrow-right',
    'arrow-top',
    'check',
    'chevron-double-left',
    'chevron-double-right',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'chevron-up',
    'copy',
    'cross',
    'download',
    'magnifying-glass',
    'minus',
    'pencil',
    'plus',
    'star',
    'trash',
    'upload',
    'user',
    'wheel',
  ],
} as const;

export declare type IconSize = 'L' | 'M' | 'S' | 'XS';

export declare type IconNameWithSize<S extends IconSize> =
  (typeof icons)[S][number];

export declare type Icon<S extends IconSize> = {
  size: S;
  name: IconNameWithSize<S>;
};
